/* ===========================
   Savage Industries — Theme Helpers
   =========================== */

/* ---------- 1) Sticker Grid (with dynamic header) ---------- */
/*                                                             */
/* ------------------------------------------------------------*/
(function () {
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function initGrid(root) {
    if (!root) return;

    const variantGrid = root.querySelector('[data-target="variant"]');
    const headerSpan =
      root.querySelector('.sticker-grid__pack-name') ||
      document.querySelector('.sticker-grid__pack-name');

    if (!variantGrid) return;

    const map = JSON.parse(root.getAttribute('data-variant-map') || '{}');
    const initial = root.getAttribute('data-initial-variant');

    function readVariantId() {
      // 1) Prefer the ?variant=... URL param (Impulse keeps this in sync)
      try {
        const params = new URLSearchParams(window.location.search);
        const fromUrl = params.get('variant');
        if (fromUrl) {
          return String(fromUrl);
        }
      } catch (e) {
        console.warn('[stickers] URLSearchParams failed', e);
      }

      // 2) Fallback to the product form, if present
      const form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return null;

      return (
        form.querySelector('input[name="id"][type="hidden"]')?.value ||
        form.querySelector('select[name="id"]')?.value ||
        form.querySelector('input[name="id"][type="radio"]:checked')?.value ||
        null
      );
    }

    function updateHeaderById(variantId) {
      if (!headerSpan) return;
      const entry = map[String(variantId)];
      const title = entry && entry.title;
      headerSpan.textContent = title || 'Pack';
    }

    function render(variantId) {
      const entry = map[String(variantId)] || {};
      const names = entry.names || [];

      //console.log('[stickers] render for', variantId, entry);

      if (names.length) {
        variantGrid.innerHTML = names
          .map(function (n) {
            return (
              '<div class="sticker-item"><span class="sticker-name">' +
              escapeHtml(n) +
              '</span></div>'
            );
          })
          .join('');
      } else {
        variantGrid.innerHTML =
          '<div class="sticker-item"><em>No stickers listed.</em></div>';
      }

      updateHeaderById(variantId);
    }

    // Bind form & custom events
    const form = document.querySelector('form[action*="/cart/add"]');
    const update = function () {
      setTimeout(function () {
        render(readVariantId() || initial);
      }, 0);
    };

    if (form) {
      form.addEventListener('change', update, true);
      form.addEventListener('input', update, true);
      form.addEventListener('click', update, true);
    }

    ['variant:change', 'variantChange', 'product:variant-change', 'theme:variant:change'].forEach(
      function (evt) {
        document.addEventListener(evt, function (e) {
          const id = (e && e.detail && (e.detail.variant && e.detail.variant.id)) || e?.detail?.id;
          render(id || readVariantId() || initial);
        });
      }
    );

    // Initial render
    render(readVariantId() || initial);
  }

  // Boot + Theme Editor events
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sticker-grid-wrap').forEach(initGrid);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.sticker-grid-wrap').forEach(initGrid);
  });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('.sticker-grid-wrap').forEach(initGrid);
  });
})();

/* ---------- 2) Prefer #hero media once (no obs leak) ---------- */
/*                                                                */
/* ---------------------------------------------------------------*/
(function(){
  function preferHeroOnce() {
    const heroThumb = document.querySelector(
      '[data-product-thumbs] [data-product-thumb] img[alt*="#hero"],' +
      '[data-product-thumbs] [data-media-thumbnail] img[alt*="#hero"],' +
      '.product__thumb img[alt*="#hero"]'
    );
    if (!heroThumb) return;
    const clickable = heroThumb.closest('[data-product-thumb],[data-media-thumbnail],.product__thumb');
    clickable?.click();
  }

  const root = document.querySelector('[data-product-images]');
  if (!root) return;

  const thumbsReady = () =>
    root.querySelector('[data-product-thumbs]') ||
    root.querySelector('[data-media-thumbnail]') ||
    root.querySelector('.product__thumb');

  if (thumbsReady()) { preferHeroOnce(); return; }

  let obs = new MutationObserver(() => {
    if (thumbsReady()) {
      preferHeroOnce();
      obs.disconnect();
    }
  });
  obs.observe(root, { childList: true, subtree: true });
})();

/* ---------- 3) Global flags + drawer hider ---------- */
/*                                                      */
/* ---------------------------------------------------- */
window.SI_SUPPRESS_CART_DRAWER = false;   // restore theme drawer
window.SI_ENABLE_CONFETTI      = true;    // keep confetti on add (set to false if you want it off)
const SI_CONFETTI_STYLE = 'retro-pixels'

// Global helper so any block can hide the drawer briefly
window.SI_temporarilyHideDrawer = function(ms=800){
  document.documentElement.classList.add('si-hide-drawer');
  setTimeout(()=> document.documentElement.classList.remove('si-hide-drawer'), ms);
};

/* ---------- 4) Add-to-cart animations only (no interception) ---------- */
/*                                                                        */
/* ---------------------------------------------------------------------- */
(function(){
  function animatePlusOne(targetEl, amount){
    try {
      const rect = (targetEl && targetEl.getBoundingClientRect)
        ? targetEl.getBoundingClientRect()
        : { left: window.innerWidth/2, top: (window.scrollY || 0) + window.innerHeight/2, width: 0 };

      const el = document.createElement('div');
      el.className = 'si-plusone';
      el.textContent = '+' + String(amount || 1);
      el.style.left = (rect.left + rect.width/2 + window.scrollX) + 'px';
      el.style.top  = (rect.top + window.scrollY - 6) + 'px';

      document.body.appendChild(el);
      requestAnimationFrame(() => el.classList.add('in'));
      setTimeout(() => el.remove(), 1000);
    } catch(_){}
  }

  function readQtyFromButtonOrForm(btn){
    const form = btn && btn.closest ? btn.closest('form') : null;

    // 1) Try inside the form (normal case)
    let qEl =
      (form && form.querySelector('input[name="quantity"]')) ||
      (form && form.querySelector('.js-qty__num')) ||
      (form && form.querySelector('.quantity__input')) ||
      null;

    // 2) Qty UI outside the form (Impulse-style): find any input whose form="FORM_ID"
    if (!qEl && form && form.id) {
      const candidates = document.querySelectorAll('input[name="quantity"][form], .js-qty__num[form], .quantity__input[form]');
      for (const el of candidates) {
        if (el.getAttribute('form') === form.id) {
          qEl = el;
          break;
        }
      }
    }

    const q = qEl ? parseInt(qEl.value, 10) : 1;
    return Number.isFinite(q) && q > 0 ? q : 1;
  }
  
  function pickConfettiStyle(targetEl) {
    // Helpers for getting an explicit value from data-confetti-style
    function findExplicitStyle(node) {
      if (!node) return null;
      const holder = node.closest('[data-confetti-style]');
      if (!holder || !holder.dataset.confettiStyle) return null;
      return holder.dataset.confettiStyle;
    }

    let explicit = null;

    // 1) Try nearest element around the clicked button
    if (targetEl && targetEl.closest) {
      explicit = findExplicitStyle(targetEl);
    }

    // 2) Fall back to any global holder (e.g. product section)
    if (!explicit) {
      const globalHolder = document.querySelector('[data-confetti-style]');
      if (globalHolder && globalHolder.dataset.confettiStyle) {
        explicit = globalHolder.dataset.confettiStyle;
      }
    }

    // Normalize
    if (explicit) {
      explicit = String(explicit).trim().toLowerCase();
    }

    const styles = [
      'classic',
      'maker-sparks',
      'dense-pop',
      'comic-poof',
      'sticker-pop',
      'ascii-burst',
      'retro-pixels'
    ];

    // If metafield says "random", treat it as no explicit style
    if (explicit === 'random') {
      explicit = null;
    }

    // If explicit matches a known style, use it
    if (explicit && styles.indexOf(explicit) !== -1) {
      return explicit;
    }

    // Otherwise: random
    return styles[Math.floor(Math.random() * styles.length)];
  }

  function confettiBurst(targetEl){
    try {
      const rect = (targetEl && targetEl.getBoundingClientRect)
        ? targetEl.getBoundingClientRect()
        : { left: window.innerWidth/2, top: (window.scrollY || 0) + window.innerHeight/2, width: 0 };

      const originX = rect.left + rect.width / 2 + window.scrollX;
      const originY = rect.top + window.scrollY;

      const style = pickConfettiStyle(targetEl);

      // Per-style config: number of pieces + spread
      const STYLE_CONFIG = {
        'classic': {
          N: 18,
          spreadX: 120,
          spreadY: 180
        },
        'maker-sparks': {
          N: 24,
          spreadX: 80,
          spreadY: 220
        },
        'dense-pop': {
          N: 32,
          spreadX: 140,
          spreadY: 220
        },
        'comic-poof': {
          N: 14,
          spreadX: 90,
          spreadY: 140
        },
        'sticker-pop': {
          N: 20,
          spreadX: 130,
          spreadY: 190
        },
        'ascii-burst': {
          N: 22,
          spreadX: 110,
          spreadY: 200
        },
        'retro-pixels': {
          N: 26,
          spreadX: 120,
          spreadY: 210
        }
      };

      const cfg = STYLE_CONFIG[style] || STYLE_CONFIG['classic'];

      for (let i = 0; i < cfg.N; i++) {
        const p = document.createElement('i');
        p.className = 'si-confetti si-confetti--' + style;
        p.style.left = originX + 'px';
        p.style.top  = originY + 'px';

        // Randomize direction + rotation based on spread
        p.style.setProperty('--dx',  (Math.random() * 2 - 1) * cfg.spreadX + 'px');
        p.style.setProperty('--dy',  (Math.random() * -1 - 0.2) * cfg.spreadY + 'px');
        p.style.setProperty('--rot', (Math.random() * 360) + 'deg');

        //document.body.appendChild(p);
        // pick a container inside the same stacking context as the overlay/drawer
        const container =
          document.querySelector('[data-cart-drawer]') ||
          document.querySelector('.drawer') ||
          document.body;

        container.appendChild(p);

        requestAnimationFrame(() => p.classList.add('in'));
        setTimeout(() => p.remove(), 1200);
      }
    } catch (_){}
  }

  let lastAnimAt = 0;
  function triggerAnimations(btn){
    const now = Date.now();
    if (now - lastAnimAt < 200) return;
    lastAnimAt = now;

    const qty = readQtyFromButtonOrForm(btn);
    animatePlusOne(btn, qty);
    if (window.SI_ENABLE_CONFETTI) confettiBurst(btn);
  }

  function bindFormAnimations(root){
    root = root || document;

    // Forms that post to /cart/add
    const forms = root.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
    forms.forEach(form => {
      if (form.__si_anim_bound) return;
      form.__si_anim_bound = true;

      form.addEventListener('submit', e => {
        const btn = form.querySelector('[type="submit"],button[name="add"]') || form;
        triggerAnimations(btn);
      }, true);
    });

    // Buttons that might trigger add-to-cart via JS
    /*
    const buttons = root.querySelectorAll(
      'form[action="/cart/add"] [type="submit"], ' +
      'form[action*="/cart/add"] [type="submit"], ' +
      'button[name="add"], ' +
      '[data-add-to-cart]'
    );

    buttons.forEach(btn => {
      if (btn.__si_anim_bound) return;
      btn.__si_anim_bound = true;
      btn.addEventListener('click', e => {
        triggerAnimations(btn);
      }, true);
    });
  */
  }
  document.addEventListener('DOMContentLoaded',  () => bindFormAnimations(document));
  document.addEventListener('shopify:section:load',   e => bindFormAnimations(e.target));
  document.addEventListener('shopify:section:select', e => bindFormAnimations(e.target));

  // Debug helper: run SI_debugConfetti() in the console
  window.SI_debugConfetti = function(){
    const btn =
      document.querySelector('form[action="/cart/add"] [type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] [type="submit"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('[data-add-to-cart]') ||
      document.body;

    triggerAnimations(btn);
  };
})();

// --- Keep Order Note in sync with cart Personalization (variant-only label) --- */
/*                                                                                */
/* ------------------------------------------------------------------------------ */

async function rebuildCartNoteFromCart() {
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

    const lines = [];
    const seen = new Set();

    for (const it of (cart.items || [])) {
      const p = it.properties || {};
      const val = (p['Personalization'] || '').toString().trim();
      if (!val) continue;

      const product = (it.product_title || '').trim();
      const variant = (it.variant_title || '').trim();
      const hasVariant = variant && variant.toLowerCase() !== 'default title';

      const PRODUCT_ALIASES = {
        "Adam's Book Signed and Personalized (Every Tool's a Hammer: Life Is What You Make It)": "Book",
        "Signed and Personalized 8x10 photo of Adam Savage": "8×10 Photo",
        "Adam Savage's Modelmaking Toolbox Poster Signed and Personalized": "Toolbox Poster"
      };
      //const displayName = hasVariant ? variant : product; // <— variant takes precedence
      const displayName = hasVariant ? variant : (PRODUCT_ALIASES[product] || product);
      const qty = Number(it.quantity || 1);
      const qtyPart = qty > 1 ? ` ×${qty}` : '';

      // De-dupe by product+variant+text+qty (so repeated adds don’t stack)
      const key = `${product}|||${variant}|||${val}|||${qty}`;
      if (seen.has(key)) continue;
      seen.add(key);

      lines.push(`${displayName}${qtyPart}: Personalization: ${val}`);
    }

    const note = lines.length ? '• ' + lines.join('\n• ') : '';

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note })
    });

    const ta = document.querySelector('textarea[name="note"]');
    if (ta) ta.value = note;
  } catch (e) {
    console.warn('rebuildCartNoteFromCart failed', e);
  }
}

// Make callable from product snippet (if you need it)
window.rebuildCartNoteFromCart = rebuildCartNoteFromCart;

// Hooks (unchanged)
document.addEventListener('cart:updated', rebuildCartNoteFromCart);
document.addEventListener('cart:refresh', rebuildCartNoteFromCart);
window.addEventListener('cart:updated', rebuildCartNoteFromCart);
document.addEventListener('click', (e) => {
  if (e.target.matches('[data-cart-remove], .cart__remove, button[name="remove"], [href*="cart/change"]') ||
      e.target.closest('[data-cart-remove], .cart__remove')) {
    setTimeout(rebuildCartNoteFromCart, 350);
  }
});
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="updates[]"], input[name="quantity"], .quantity__input')) {
    setTimeout(rebuildCartNoteFromCart, 350);
  }
});
document.addEventListener('DOMContentLoaded', rebuildCartNoteFromCart);


/* ----- START CODE for displaying quantity left for variants ----- */
/* MOT 20251117                                                     */
/* ------------===------------------------------------------------- */

(function () {
  function getCurrentVariant() {
    // Find the main product form and current variant selector
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return null;
    var select = form.querySelector('[name="id"]');
    if (!select) return null;

    var variantId = select.value;
    if (!variantId) return null;

    // Find the hidden inventory data for this variant
    var root = document.querySelector('.js-product-inventory-data[data-product-id]');
    if (!root) return null;

    var node = root.querySelector('.js-variant-inventory-data[data-id="' + variantId + '"]');
    if (!node) return null;

    var qty = Number(node.getAttribute('data-quantity') || 0);
    var policy = node.getAttribute('data-policy') || '';
    var incoming = node.getAttribute('data-incoming') === 'true';

    return {
      id: Number(variantId),
      quantity: qty,
      policy: policy,
      incoming: incoming,
      available: qty > 0
    };
  }

  function refreshInventorySpan() {
    var el = document.querySelector('[data-product-inventory][data-show-qty-left="true"]');
    if (!el) return;

    var v = getCurrentVariant();
    if (!v) return;

    // If not tracked or not available, let the theme handle its own messaging
    if (!v.available) {
      return;
    }

    var threshold = Number(el.getAttribute('data-threshold') || 5);
    var base = el.getAttribute('data-instock-label') || 'In stock, ready to ship';

    if (v.quantity > threshold) {
      el.textContent = base + ' — ' + v.quantity + ' available';
    } else {
      el.textContent = 'Only ' + v.quantity + ' left!';
    }
  }

  function scheduleRefresh() {
    // Let the theme finish its own variant-change logic first
    setTimeout(refreshInventorySpan, 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Let Impulse write its initial text, then adjust
    setTimeout(refreshInventorySpan, 60);
  });

  // Theme variant change events
  document.addEventListener('variant:change', scheduleRefresh);
  document.addEventListener('product:variant-change', scheduleRefresh);

  // Fallback: listen for direct changes to the variant select
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') {
      scheduleRefresh();
    }
  });
})();

  (function () {
    function getCurrentVariantId() {
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return null;
      var select = form.querySelector('[name="id"]');
      if (!select) return null;
      return select.value || null;
    }

    function updateLimitedBadge() {
      var wrapper = document.querySelector('[data-limited-wrapper]');
      var labelEl = document.querySelector('[data-limited-label]');
      if (!wrapper || !labelEl) return;

      var vid = getCurrentVariantId();
      if (!vid) return;

      var root = document.querySelector('.js-variant-flags[data-product-id]');
      if (!root) return;

      var node = root.querySelector('.js-variant-flag[data-id="' + vid + '"]');
      if (!node) {
        wrapper.classList.add('hide');
        return;
      }

      var isLimited = node.getAttribute('data-limited') === 'true';
      var label = node.getAttribute('data-limited-label') || labelEl.textContent || 'Limited edition';

      if (isLimited) {
        wrapper.classList.remove('hide');
        labelEl.textContent = label;
      } else {
        wrapper.classList.add('hide');
      }
    }

    function scheduleUpdate() {
      // Let the theme finish its variant-change logic first
      setTimeout(updateLimitedBadge, 0);
    }

    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(updateLimitedBadge, 60);
    });

    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('product:variant-change', scheduleUpdate);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        scheduleUpdate();
      }
    });
  })();

    (function () {
    var RETIRED_VALUE = "52708396499228"; // Red/Bronze (RETIRED) variant ID
    var HIDDEN_VALUE = ""; // Light Blue

    function pruneBisOptions() {
      var select = document.getElementById('backInStockFormVariantSelect');
      if (!select) return;

      var options = Array.prototype.slice.call(select.options || []);
      options.forEach(function (opt) {
        if (opt.value === RETIRED_VALUE || opt.value === HIDDEN_VALUE || opt.text.indexOf('Red/Bronze') !== -1 || opt.text.indexOf('Light Blue') !== -1) {
          opt.remove();
        }
      });

      // If that variant was selected by default, nudge the selection to the first remaining option
      if (!select.value && select.options.length > 0) {
        select.selectedIndex = 0;
      }
    }

    // Run once when the popup has had a chance to render
    document.addEventListener('DOMContentLoaded', function () {
      // initial pass (for cases where popup is already present)
      setTimeout(pruneBisOptions, 500);

      // Watch for the popup being injected later
      var observer = new MutationObserver(function () {
        pruneBisOptions();
      });

      observer.observe(document.body, { childList: true, subtree: true });
    });
  })();